import React, { useEffect, useState, useRef } from "react";
import { updateDOB } from "../../Services/employee";
import { message, Modal } from "antd";
import LoadingButton from '@mui/lab/LoadingButton';
import DatePicker from 'react-date-picker';
import moment from "moment";

const DateOfBirth = ({ DateOfBirthData, setFlag, flag }) => {
    const [InitialDate, setInitialDate] = useState(null);
    const [loading, setLoading] = useState(false);
    const datePickerRef = useRef();
    const saveButtonRef = useRef();
    const { open, close, employeeDetails } = DateOfBirthData;

    useEffect(() => {
        if (employeeDetails?.dateOfBirth) {
            const date = new Date(moment(new Date(employeeDetails.dateOfBirth)?.toUTCString())?.utc()?.format("MM-DD-YYYY"))
            setInitialDate(date);
        }
    }, [DateOfBirthData, employeeDetails]);

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && datePickerRef.current) {
            datePickerRef.current.closeCalendar();
            saveButtonRef.current.focus();
        } else if (event.key === 'Tab' && saveButtonRef.current) {
            event.preventDefault(); // Prevent the default tab behavior
            saveButtonRef.current.focus(); // Focus the save button
        }
    };

    const handleSubmission = async () => {
        if (!InitialDate) return message.error("Please select any date!");
        setLoading(true);
        const convertedDate = moment(InitialDate).format("M/D/YYYY");
        let data = { dateOfBirth: convertedDate };

        try {
            const result = await updateDOB(employeeDetails.id, data);
            if (result.httpStatus === 200) {
                setFlag(!flag);
                message.success('Date of birth Updated');
            }
        } catch (e) {
            // Handle error
        } finally {
            close(true);
            setLoading(false);
        }
    };


    return (
        <Modal
            open={open}
            onCancel={() => close()}
            title={"Edit date of birth"}
            footer={false}
        >
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                <DatePicker
                    ref={datePickerRef}
                    value={InitialDate}
                    onChange={(date) => setInitialDate(date)}
                    // format={"MM/dd/yyyy"}
                    clearIcon={null}
                    id="dob"
                    type='date1'
                    style={{ background: 'white', borderRadius: '10px' }}
                    className="datePickerReact w100p bg-white react-date-picker"
                    onKeyDown={handleKeyDown} // Add key down handler
                />
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <LoadingButton
                        ref={saveButtonRef}
                        loading={loading}
                        onClick={handleSubmission}
                        style={{ width: "50%" }}
                        className="LinkButton"
                    >
                        Save
                    </LoadingButton>
                </div>
            </div>
        </Modal>
    );
};

export default DateOfBirth;